import type { UserType } from '~settings/api/lib/schemas';

export const UserTypeMap: Record<UserType, string> = {
  SUPERADMIN: 'superAdmin',
  ADMIN: 'admin',
  MANAGER: 'manager',
  VIEWER: 'viewer',
  EXTERNAL: 'external',
  // deprecated user types below
  INTERNAL: 'internal',
} as const;
